import React, { useRef, useEffect } from "react";
import { Field } from "formik";
import CurrentName from "./CurrentName";

const TextValueField = ({
    name,
    label,
    withLineBreak=true,
    lineBreakInCurrentName,
    type,
    formValue,
    currValue,
    isPrice,
    activeField,
    setActiveField,
}) => {
    const editing = activeField === name;
    const inputRef = useRef(null);

    const closeInput = () => {
        setActiveField("");
    };

    const checkEnter = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            closeInput();
        }
    };

    useEffect(() => {
        const inp = inputRef.current;
        inp.addEventListener("keypress", checkEnter);
        inp.addEventListener("blur", closeInput);
        return () => {
            inp.removeEventListener("keypress", checkEnter);
            inp.removeEventListener("blur", closeInput);
        };
    }, [editing]);

    return (
        <p onClick={() => setActiveField(name)} className="text-value-field">
            {label && (
                <label htmlFor={name} className="text-small-light">
                    {label + ":"}
                </label>
            )}
            {withLineBreak && <br />}
            <span className="editing-wrapper">
                <span
                    className={"editing-element" + (editing ? " hidden" : "")}
                >
                    <CurrentName
                        lineBreakInCurrentName={lineBreakInCurrentName}
                        formValue={formValue}
                        currValue={currValue}
                        formName={formValue}
                        currName={currValue}
                        isPrice={isPrice}
                    />
                </span>
                <span
                    className={"editing-element" + (!editing ? " hidden" : "")}
                >
                    <Field
                        id={name}
                        className={"input-text-box"}
                        type={type}
                        name={name}
                        innerRef={inputRef}
                    />
                </span>
            </span>
        </p>
    );
};

export default TextValueField;
